import { useState } from 'react';
import { MapPin, Hash, Globe } from 'lucide-react';
import { CitiesPanel } from './CitiesPanel';
import { StatesPanel } from './StatesPanel';
import { PincodesPanel } from './PincodesPanel';

export function MastersPage() {
  const [tab, setTab] = useState<'states' | 'cities' | 'pincodes'>('states');
  return (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-900">Masters</h1>
        <p className="text-slate-500 text-sm mt-1">Cities and Pincodes used in pickup/delivery routing, zone calculation and pricing.</p>
      </div>
      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        <div className="border-b border-slate-200 px-4 flex gap-1">
          <TabBtn active={tab === 'states'} onClick={() => setTab('states')} icon={<Globe size={14} />} label="States" />
          <TabBtn active={tab === 'cities'} onClick={() => setTab('cities')} icon={<MapPin size={14} />} label="Cities" />
          <TabBtn active={tab === 'pincodes'} onClick={() => setTab('pincodes')} icon={<Hash size={14} />} label="Pincodes" />
        </div>
        <div className="p-5">
          {tab === 'states' && <StatesPanel />}
          {tab === 'cities' && <CitiesPanel />}
          {tab === 'pincodes' && <PincodesPanel />}
        </div>
      </div>
    </div>
  );
}

function TabBtn({ active, onClick, icon, label }: { active: boolean; onClick: () => void; icon: React.ReactNode; label: string }) {
  return (
    <button onClick={onClick}
      className={`px-4 py-3 text-sm font-medium border-b-2 -mb-px transition flex items-center gap-2 ${active ? 'border-primary text-primary' : 'border-transparent text-slate-500 hover:text-slate-700'}`}>
      {icon} {label}
    </button>
  );
}
